import { createTheme } from "@mui/material/styles";
import { palette } from "./palette";
import { mixins } from "./mixins";
import { components } from "./components";

let theme = createTheme({
  palette,
  typography: {
    fontSize: 12,
  },
});

theme = createTheme(theme, {
  mixins,
  components: components(theme),
});

export default theme;
